const getters = {};

const state = {
    isConnected: false
};

const mutations = {
    SOCKET_CONNECT (state, status) {
        state.isConnected = true;
    }
};

const actions = {
    
};


export default {
    state,
    getters,
    mutations,
    actions
};
